import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { DotLoader } from "react-spinner-overlay";

export default function LoadingBox() {
  const theme = useTheme();
  return (
    <Box
      sx={{
        flex: "1",
        overflow: "auto",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          height: "200px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "16px",
        }}
      >
        <DotLoader color={theme.palette.primary.main} />
        <Typography>لطفا منتظر باشید...</Typography>
      </Box>
    </Box>
  );
}
